/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { ListSelfEmployedTransactionsQueryResponse, ListSelfEmployedTransactionsQueryParams, ListSelfEmployedTransactions400, ListSelfEmployedTransactions401, ListSelfEmployedTransactions500 } from "../entities/ListSelfEmployedTransactions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listSelfEmployedTransactions } from "../api/listSelfEmployedTransactions";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listSelfEmployedTransactionsQueryKey = (params?: ListSelfEmployedTransactionsQueryParams) => [{ url: '/api/v1/self-employed/transactions' }, ...(params ? [params] : [])] as const

export type ListSelfEmployedTransactionsQueryKey = ReturnType<typeof listSelfEmployedTransactionsQueryKey>

export function listSelfEmployedTransactionsQueryOptions(params?: ListSelfEmployedTransactionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listSelfEmployedTransactionsQueryKey(params)
        return queryOptions<ListSelfEmployedTransactionsQueryResponse, ResponseErrorConfig<ListSelfEmployedTransactions400 | ListSelfEmployedTransactions401 | ListSelfEmployedTransactions500>, ListSelfEmployedTransactionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listSelfEmployedTransactions(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает историю операций водителя: начисления, выводы и возвраты.
 * Сортировка: `created_at` по убыванию, при равной дате — `id` по возрастанию.
 * Если операций не было, ответ `200` и `transactions: []`. Это не ошибка.
 * Фильтра по категориям пока нет: во фрейме Figma «История транзакций баланса» вкладки
 * «Все / Доход / Доплата / Вывод / Другое» скрыты, ручка возвращает все операции.
 * Если вкладки включат, понадобится параметр `category`, категория определяется по `type`.
 * Элемент списка: `id`, `amount` (копейки, без знака), `created_at`, `type`.
 * `status` (`success`, `waiting`, `canceled`) есть только у `order` и `payout`.
 * У `compensation`, `refund`, `dotaion` и `achivment` поля `status` нет.
 * Знак суммы на экране клиент берёт из `type`: начисление — `order`, `compensation`,
 * `dotaion`, `achivment`; списание — `payout`, `refund`.
 * **Требования:**
 * - JWT access-токен водителя в заголовке `Authorization: Bearer <token>`. Водитель берётся
 * из токена (`user_id` в claims), заголовки `user-id` и `city-id` не нужны и не учитываются
 * **Пагинация:**
 * - Курсорная пагинация
 * - `limit` — количество записей (1–100, по умолчанию 20)
 * - `cursor` — курсор следующей страницы (`next_cursor` из предыдущего ответа).
 * Непрозрачная строка: фронт передаёт её как есть, не разбирает и не собирает
 * @summary История транзакций
 * {@link /api/v1/self-employed/transactions}
 */
export function useListSelfEmployedTransactions<TData = ListSelfEmployedTransactionsQueryResponse, TQueryData = ListSelfEmployedTransactionsQueryResponse, TQueryKey extends QueryKey = ListSelfEmployedTransactionsQueryKey>(params?: ListSelfEmployedTransactionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListSelfEmployedTransactionsQueryResponse, ResponseErrorConfig<ListSelfEmployedTransactions400 | ListSelfEmployedTransactions401 | ListSelfEmployedTransactions500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listSelfEmployedTransactionsQueryKey(params)
         

         const query = useQuery({
          ...listSelfEmployedTransactionsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListSelfEmployedTransactions400 | ListSelfEmployedTransactions401 | ListSelfEmployedTransactions500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}